module.exports = __webpack_public_path__ + "static/media/cask-shadow-masked.675b8241.png";